<template>
  <b-container>
    <div v-if="this.$route.params.slug !== undefined">
      <b-col v-if="form.content_type==1" class="text-left">
        <router-link :to="{ name: 'PostsDashboard' }">
          <b-button pill variant="purple" class="ml-1 mb-1"
          > بازگشت به صفحه پست ها
          </b-button
          >
        </router-link>
      </b-col>

      <b-col v-if="form.content_type==0" class="text-left">
        <router-link :to="{ name: 'PagesDashboard' }">
          <b-button pill variant="purple" class="ml-1 mb-1"
          > بازگشت به صفحه برگه ها
          </b-button
          >
        </router-link>
      </b-col>
    </div>

    <b-form @submit.prevent="onSubmit">
      <h5>{{ title }}</h5>

      <name-and-link-manager v-if="form.content_type == 1"
                             :router-link="{ name: 'SinglePost', params: { slug: form.titleAndSlug.link } }"
                             :label="'عنوان'"
                             v-model="form.titleAndSlug"
                             :validation="$v.form.titleAndSlug.name">
        <published-checkbox label="وضعیت انتشار" v-model="form.status"/>

      </name-and-link-manager>

      <name-and-link-manager v-else
                             :router-link="{ name: 'SinglePage', params: { slug: form.titleAndSlug.link } }"
                             :label="'عنوان'"
                             v-model="form.titleAndSlug"
                             :validation="$v.form.titleAndSlug.name">
        <published-checkbox label="وضعیت انتشار" v-model="form.status"/>

      </name-and-link-manager>


      <b-row class="mt-5 mb-2"> عکس</b-row>
      <b-row>
        <b-col sm="3" md="3">
          <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                        :validation="$v.form.mainImage"></single-image>
        </b-col>
      </b-row>

      <b-row class="mt-5">مشخصات</b-row>
      <b-row class="mt-2">
        <radio-box :label="'انتخاب نوع محتوا'" :radioItems="content_typeList" v-model="form.content_type"
                   :validation="$v.form.content_type" :isBrand="false"/>
        <check-box-manager :CheckBoxItems="categories" :label="'انتخاب دسته بندی'"
                           :selectedCheckBoxes="form.selectedCategory" :validation="$v.form.selectedCategory"/>
      </b-row>

      <b-row class="mt-5">
        <form-group :validations="$v.form.abstraction" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>چکیده</label>
            <div class="form-group">
              <vue-editor :editor-toolbar="defaultToolbar" dir="ltr" v-model="form.abstraction"/>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>
      </b-row>

      <b-row class="mt-5">

        <form-group :validations="$v.form.body" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>متن</label>
            <b-row>
              <b-col lg="6">
                <AddImageToEditor @image-handler="imageHandlerFunction" :title="form.titleAndSlug"/>
              </b-col>
              <b-col lg="6">
                <AddVideoToEditor @video-handler="videoHandlerFunction"/>
              </b-col>
            </b-row>
            <div class="form-group">
              <vue-editor :editor-toolbar="defaultToolbar" dir="ltr" v-model="form.body"/>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-row>
      <key-words-manager :keyWords="form.keyWords" :TableItems="form.table"/>

      <b-row class="my-5">
        <b-col md="8" class="m-auto">
          <b-button pill type="submit" variant="purple" class="w-100"
          >تایید
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>
<script>
import router from '@/router';
import {mapGetters} from "vuex";
import category from "../product/category.vue";
import {required, numeric} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import NameAndLinkManager from "./FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "./FormItems/PublishedCheckbox.vue";
import SingleImage from "./FormItems/SingleImage.vue";
import RadioBox from "./FormItems/RadioBox.vue";
import CheckBoxManager from "./FormItems/CheckBoxManager.vue";
import FormInput from "./FormItems/FormInput.vue";
import FormTextArea from "./FormItems/FormTextArea.vue";
import KeyWordsManager from "./FormItems/KeyWordsManager.vue";
import {VueEditor} from "vue2-editor";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import AddImageToEditor from "./FormItems/AddImageToEditor";
import AddVideoToEditor from "./FormItems/AddVideoToEditor";


export default {
  name: "CreateContentLayout",
  components: {
    category,
    FormGroup,
    FormErrorsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    KeyWordsManager,
    VueEditor,
    AddImageToEditor,
    AddVideoToEditor,
  },
  props: ["title", "submitFunction"],
  data() {
    return {
      fields: [
        {key: "name", label: "کلمه کلیدی"},
        {key: "action", label: ""},
      ],
      form: {
        titleAndSlug: {name: "", link: ""},
        mainImage: [],
        content_type: '',
        selectedCategory: [],
        free: null,
        course_status: null,
        section_name: null,
        status: false,
        abstraction: "",
        body: "",
        keyWords: [],
        table: [],
        mainPreview: "",
      },
      content_typeList: [
        {name: "پست", id: '1'},
        {name: "برگه", id: '0'},
      ],
      defaultToolbar
    };
  },
  validations: {
    form: {
      titleAndSlug: {name: {required}},
      selectedCategory: {required},
      content_type: {required},
      abstraction: {required},
      body: {required},
      mainImage: {
        required: (value) => {

          return router.currentRoute.params.slug != undefined || value.length !== 0

        }
      }
    },
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = {title: this.form.titleAndSlug.name, slug: this.form.titleAndSlug.link, ...this.form};
        this.submitFunction(form);
      }
    },
    imageHandlerFunction(image) {
      this.form.body += image;
    },
    videoHandlerFunction(video) {
      this.form.body += video;
    },
    async setContent() {
      const routerslug = this.$route.params.slug;
      if (routerslug !== undefined) {
        this.form.titleAndSlug.link = routerslug;
        this.$store
            .dispatch("Content/getDashboardContent", this.form.titleAndSlug.link)
            .then(async (res) => {
              this.form.titleAndSlug.name = await res.title;
              this.form.id = await res.id;
              this.form.titleAndSlug.link = await res.slug;
              this.form.content_type = await res.content_type
              this.form.status = await res.status ? true : false;
              this.form.mainPreview = await res.thumbnail;
              this.form.free = await res.free;
              this.form.course_status = await res.course_status;
              this.form.section_name = await res.section_name;
              this.form.author = await res.author.id;
              this.form.description = await res.description;
              this.form.abstraction = await res.abstraction;
              this.form.body = await res.body;

              await res.category.forEach((category) => {
                try {
                  document
                      .getElementById(`category_${category.id.toString()}`)
                      .click();
                } catch (e) {
                  console.log(`category not found: ${e}`)
                }

              });

              document.getElementById(`item_${this.form.content_type}`).click();

              res.keywords.forEach((keyword) => {
                this.form.keyWords.push(keyword.keyword);
                this.form.table.push({name: keyword.keyword});
              });
            })
            .catch((err) => {
              console.log(err);
            });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("Category/getCategories");

    setTimeout(async () => {
      await this.setContent()
    }, 500)


  },
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>